import type { UnreadHint, UnreadHintResponse } from '@/api/unreadHint/types';
import { useDelete, useGet } from "@/api/lib/integration";

export const getAll = useGet<void, UnreadHintResponse>('/api/unread-hints');
export const remove = useDelete<UnreadHint[], UnreadHintResponse>('/api/unread-hints');
